module.exports = __webpack_public_path__ + "img/空调.e195235b.png";